// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"161":"poi","806":"user"}[chunkId] + "." + {"161":"80da6af5","806":"24346dad"}[chunkId] + ".css";
};